import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const ProducerPolicyholderDetails = lazy(
  () => import('@pages/producer/ProducerPolicyholderDetails'),
);

export const ProducerPolicyholderDetailsRoutes: RouteObject[] = [
  {
    path: '/producer-policyholder-details',
    element: (
      <React.Suspense>
        <ProducerPolicyholderDetails />
      </React.Suspense>
    ),
  },
];